export default __webpack_public_path__ + "static/media/logo.472897d2.svg";